<template>
    <div class="panel-body">
        <div v-for="group in channel.items" :key="group.groupingName">
            <div class="row">
                <div class="col-md-12 clearfix">
                    <h3>{{group.groupingName}}</h3>
                </div>
            </div>
            <input-loader :fields="group.groupItems"></input-loader>
        </div>

        <div class="form-group row">
            <div class="col-md-9 ml-auto text-right">
                <button v-on:click="saveMagento2()" type="button" class="btn btn-primary">Save</button>
                <a :href="baseUrl+ '/channels'" class="btn btn-secondary">
                    Cancel
                </a>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host;
    import InputLoader from "../form/form-loader.vue";
    import getNestedProperty from "../../mixins/getNestedProperty.js";
    import addCommonSettings from "./common-settings.js";

    export default {
        name: "magento2-specific",
        components: {
            "input-loader": InputLoader,
        },
        mixins: [getNestedProperty, addCommonSettings],
        props: ['channelvalues', 'channeloptions'],
        data() {
            return {
                channel: {
                    items: [],
                },
                alert: {
                    message: "",
                    status: "alert-success",
                    timeOut: 15000,
                },
                baseUrl: base_url,
                canSeeAdminFields: dataObject.canSeeAdminFields,
                postURL: base_url + "/channels/" + dataObject.channel.id,
                loading: false
            };
        },
        methods: {
            saveMagento2: function () {
                this.loading = true;
                this.$emit("channel-specific-save", this.channel);
            },
            setItems: function () {
                var cvs = this.channelvalues;
                var cfo = this.channeloptions;

                this.channel.items = [
                    {
                        groupingName : "Settings",
                        groupItems : [
                            {
                                name : "magento2_attribute_sets",
                                label : "Attribute Sets",
                                type : "multiselect",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'magento2_attribute_sets')) ? cvs.json_options.configuration.magento2_attribute_sets  : "",
                                options : (cfo.attributeSetValues) ? cfo.attributeSetValues : [],
                                tooltip: 'Attribute sets that apply to this channel',
                                tooltip_position: 'top'
                            },
                            {
                                name : "magento2_default_attributes",
                                label : "Import Default Attributes (select which default attributes you want to import into the PIM)",
                                type : "multiselect",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'magento2_default_attributes')) ? cvs.json_options.configuration.magento2_default_attributes  : "",
                                options : (cfo.defaultAttributes) ? cfo.defaultAttributes : [],
                                tooltip: 'Select which default attributes you want to import into the PIM',
                                tooltip_position: 'top'
                            },
                            {
                                name : "parent_categories",
                                label : "Push Parent Categories",
                                required : false,
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'parent_categories')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Push the parent categories of the products synced'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Parent categories will not be pushed to the store'
                                    }
                                ],
                                tooltip: 'Push parent categories of the products synced',
                                tooltip_position: 'top'
                            }
                        ]
                    }
                ];
            }
        },
        mounted() {
            this.setItems();
            this.channel.items = this.addCommonSettings(this.channel.items, this.channelvalues, this.channeloptions);
        },
    };
</script>